import { takeEvery } from '@zaibot/fsa-saga';
import { fork, put, select } from '../redux-saga';
import { participantsBatch, participantsEditor, participantsResource } from './resource';
import { useridResource } from '../participantid/resource';
import LOGGEDOUT from '../auth/actions/LOGGEDOUT';
import PARTICIPANTS_LOADED from './actions/PARTICIPANTS_LOADED';
import USER_ID_LOADED from '../participantid/actions/USER_ID_LOADED';

export function* rootSaga(): Iterable<any> {
    yield fork(participantsResource.saga);
    yield fork(participantsEditor.saga);
    yield fork(participantsBatch.saga);
    yield fork(signalLoadAllParticipants);    
    yield fork(signalLoadAllParticipantsSuccess);    
    yield fork(signalParticipantReset);  

}

function* signalLoadAllParticipants() {
    yield takeEvery(USER_ID_LOADED, function*(){
        const users = yield select(useridResource.selectors.items);
        yield put(participantsResource.actions.LIST({ params: { id: users?users[0].id:''}}));
    });
}

function* signalLoadAllParticipantsSuccess() {
    yield takeEvery<any,any>([ participantsResource.actions.LIST_SUCCESS, 
        ], function*(action){
            yield put(PARTICIPANTS_LOADED({}));
    });
}

function* signalParticipantReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(participantsResource.actions.RESET({ }));
        yield put(participantsEditor.actions.RESET({ }));
        yield put(participantsBatch.actions.RESET({ }));
    }); 
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/participant/sagas.tsx